__turbopack_context__.v({
  "glassSurface": "PdpMobileTourBanner-module__9BN-7q__glassSurface",
  "shell": "PdpMobileTourBanner-module__9BN-7q__shell",
});
